import Image from '@atlaskit/image';
import filterButtonAnatomyLight from "../../../../../../packages/design-system/button/constellation/filter-button/images/filter-button-anatomy-light.png";
import filterButtonAnatomyDark from "../../../../../../packages/design-system/button/constellation/filter-button/images/filter-button-anatomy-dark.png";
import filterButtonMetricDoLight from "../../../../../../packages/design-system/button/constellation/filter-button/images/filter-button-metric-do-light.png";
import filterButtonMetricDoDark from "../../../../../../packages/design-system/button/constellation/filter-button/images/filter-button-metric-do-dark.png";
import filterButtonMetricDontLight from "../../../../../../packages/design-system/button/constellation/filter-button/images/filter-button-metric-dont-light.png";
import filterButtonMetricDontDark from "../../../../../../packages/design-system/button/constellation/filter-button/images/filter-button-metric-dont-dark.png";
import filterButtonLabelDoLight from "../../../../../../packages/design-system/button/constellation/filter-button/images/filter-button-label-do-light.png";
import filterButtonLabelDoDark from "../../../../../../packages/design-system/button/constellation/filter-button/images/filter-button-label-do-dark.png";
import filterButtonLabelDontLight from "../../../../../../packages/design-system/button/constellation/filter-button/images/filter-button-label-dont-light.png";
import filterButtonLabelDontDark from "../../../../../../packages/design-system/button/constellation/filter-button/images/filter-button-label-dont-dark.png";
import * as React from 'react';
export default {
  Image,
  filterButtonAnatomyLight,
  filterButtonAnatomyDark,
  filterButtonMetricDoLight,
  filterButtonMetricDoDark,
  filterButtonMetricDontLight,
  filterButtonMetricDontDark,
  filterButtonLabelDoLight,
  filterButtonLabelDoDark,
  filterButtonLabelDontLight,
  filterButtonLabelDontDark,
  React
};